import { Container, Typography } from '@mui/material';

function AccessDeniedSite() {
  return (
    <div className="content">
      <Container>
        <Typography style={{marginTop: '50px'}} fontSize={30}>Access Denied</Typography>
      </Container>
    </div>
  );
}

export default AccessDeniedSite;
